import { Event } from './eventstore-client/EventstoreClient';

export default interface Archivable {
  archived?: boolean;
}

export interface ArchivedUpdatedEvent extends Event {
  type: 'ARCHIVED_UPDATED';
  data: { archived: boolean };
}
